import { render, staticRenderFns } from "./denticaoReportLine.vue?vue&type=template&id=3d144862&scoped=true"
import script from "./denticaoReportLine.vue?vue&type=script&lang=js"
export * from "./denticaoReportLine.vue?vue&type=script&lang=js"
import style0 from "./denticaoReportLine.vue?vue&type=style&index=0&id=3d144862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d144862",
  null
  
)

export default component.exports